/* eslint-disable max-len */
/* eslint-disable jsx-a11y/iframe-has-title */
import { useEffect } from 'react'
import { Container } from './style'
import { useProvider } from '../../provider/Provider'
import EntidadeService from '../../services/EntidadeService'
import { setCurrentEntidade } from '../../provider/actions'
import noImage from '../../assets/img/no-image.png'
import TipoEntidade from '../../model/TipoEntidade'
import { AreaDeAtuacao, Fase, PublicoAlvo } from '../../model/Entidade'

const fases = [
    { value: 'IDEAÇÃO', label: 'Ideação' },
    { value: 'VALIDAÇAO', label: 'Validação' },
    { value: 'OPERACAO', label: 'Operação' },
    { value: 'TRACAO', label: 'Tração' },
    { value: 'ESCALA', label: 'Escala' }
]

const publicoAlvoList = [
    { value: 'B2B', label: 'Empresas' },
    { value: 'B2B2C', label: 'Empresas e consumidores finais' },
    { value: 'B2C', label: 'Consumidor final' },
    { value: 'P2P', label: 'Peer-to-peer' },
    { value: 'B2S', label: 'Startups' }
]

const Visualizar = (props: any) => {
    const { match } = props
    const { params } = match
    const { id } = params
    const { currentEntidade, dispatch } = useProvider()

    useEffect(() => {
        if (currentEntidade.id === -1) {
            EntidadeService.getById(id).then((data) => {
                setCurrentEntidade(dispatch, data)
            })
        }
    }, [])

    const getUrl = () => {
        const pattern = /(\/|v=)([^/?.#&]{11})/s
        const matches = currentEntidade.pitch.match(pattern)
        const ytKey = matches ? matches[2] : ''
        return ytKey ? `https://www.youtube.com/embed/${ytKey}` : ''
    }

    function getTiposEntidades(list: TipoEntidade[]) {
        return list.map((item) => {
            return (
                <div className="sidebar-item" key={item.nome}>
                    <i className="fas fa-tag fa-sm mr-2" />
                    <span>{item.nome}</span>
                </div>
            )
        })
    }

    function getAreasDeAtuacao(list: AreaDeAtuacao[]) {
        return list.map((item) => {
            return (
                <div className="sidebar-item" key={item.nome}>
                    <i className="fas fa-chart-network mr-2" />
                    <span>{item.nome}</span>
                </div>
            )
        })
    }

    function getFase(value: Fase) {
        const current = fases.find((item) => {
            return value === item.value
        })
        return current?.label
    }

    function getPublico(value: PublicoAlvo) {
        const current = publicoAlvoList.find((item) => {
            return value === item.value
        })
        return current?.label
    }

    function getSite(site: string) {
        return site.includes('http') ? site : `https://${site}`
    }

    return (
        <Container>
            <div>
                <h1 className="header">
                    {currentEntidade.nome}
                </h1>
                <div className="section1">
                    <div className="pitch">
                        <div className={getUrl() ? 'hidden' : 'empty-video'}>
                            <i className="fab fa-youtube fa-6x" />
                            Adicione um video de pitch
                        </div>
                        <iframe
                            className={getUrl() ? '' : 'hidden'}
                            width="853"
                            height="480"
                            src={getUrl()}
                            frameBorder="0"
                            allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                            allowFullScreen
                            title="Embedded youtube"
                        />
                    </div>
                    <div className="sidebar">
                        <div className="logo1">
                            <img src={currentEntidade.logo || noImage} alt="Logo" />
                        </div>
                        <div className="sidebar-content">
                            <span>Quem somos</span>
                            {getTiposEntidades(currentEntidade.tipoEntidade)}
                            <hr />
                            <span>Area de atuação</span>
                            {getAreasDeAtuacao(currentEntidade.areaDeAtuacao)}
                        </div>
                    </div>
                </div>
                <div className="section2">
                    <nav>
                        <div className="nav nav-tabs" id="nav-tab" role="tablist">
                            <a className="nav-item nav-link active" id="nav-profile-tab" data-toggle="tab" href="#nav-profile" role="tab" aria-controls="nav-profile" aria-selected="true">
                                Perfil
                            </a>
                            <a className="nav-item nav-link" id="nav-contact-tab" data-toggle="tab" href="#nav-contact" role="tab" aria-controls="nav-contact" aria-selected="false">
                                Contato
                            </a>
                            <a className="nav-item nav-link" id="nav-location-tab" data-toggle="tab" href="#nav-location" role="tab" aria-controls="nav-location" aria-selected="false">
                                Localização
                            </a>
                        </div>
                    </nav>
                    <div className="tab-content" id="nav-tabContent">
                        <div className="tab-pane fade show active" id="nav-profile" role="tabpanel" aria-labelledby="nav-profile-tab">
                            <div className="content-box">
                                <div className="descricao-box">
                                    <h4>{currentEntidade.nome}</h4>
                                    <span>Descriçao</span>
                                    <p>{currentEntidade.descricao}</p>
                                    <span>Metas</span>
                                    <p>{currentEntidade.metas}</p>
                                </div>
                                <div className="adicional-box">
                                    <div>
                                        <span>Faturamento</span>
                                        <p>{`R$ ${currentEntidade.faturamento}`}</p>
                                        <span>Tamanho da Equipe</span>
                                        <p>{currentEntidade.tamanhoEquipe}</p>
                                    </div>
                                    <div>
                                        <span>Público Alvo</span>
                                        <p>{getPublico(currentEntidade.publicoAlvo)}</p>
                                        <span>Fase</span>
                                        <p>{getFase(currentEntidade.fase)}</p>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="tab-pane fade" id="nav-contact" role="tabpanel" aria-labelledby="nav-contact-tab">
                            <div className="content-box">
                                <span>Telefone</span>
                                <p>{currentEntidade.telefone}</p>
                                <span>Site</span>
                                <p><a href={getSite(currentEntidade.site)} target="_blank" rel="noreferrer">{currentEntidade.site}</a></p>
                                <span>Email</span>
                                <p>{currentEntidade.email}</p>
                            </div>
                        </div>
                        <div className="tab-pane fade" id="nav-location" role="tabpanel" aria-labelledby="nav-location-tab">
                            <div className="content-box">
                                <div className="adicional-box">
                                    <div>
                                        <span>Rua</span>
                                        <p>{currentEntidade.localizacao.logradouro}</p>
                                        <span>Bairro</span>
                                        <p>{currentEntidade.localizacao.bairro}</p>
                                        <span>Complemento</span>
                                        <p>{currentEntidade.localizacao.complemento}</p>
                                    </div>
                                    <div>
                                        <span>Número</span>
                                        <p>{currentEntidade.localizacao.numero}</p>
                                        <span>Cidade</span>
                                        <p>{currentEntidade.localizacao.cidade}</p>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </Container>
    )
}
export default Visualizar
